var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"employee__auctions"},[_c('div',{staticClass:"container container--employee employee-orders-list"},[_c('div',{staticClass:"row no-gutters"},[_c('AuctionsCatalogsSidebar'),_vm._v(" "),_c('div',{staticClass:"col-sm-9 auctions__list"},[_c('FinishedAuctionsCatalogsList')],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ea21a7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/employees/components/finished_auctions_catalogs.vue
// module id = 871
// module chunks = 0 1 2 3 4 5 6 7 8 10 94